import { useState } from "react";
import { AgentService } from "@/services/agent/agent.service";

export const useFileUpload = () => {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  const uploadAllFiles = async (basePath: string): Promise<string[]> => {
    if (selectedFiles.length === 0) return [];

    setIsUploading(true);
    try {
      const uploadPromises = selectedFiles.map(file =>
        AgentService.uploadSandboxFile(file, `${basePath}/${file.name}`)
      );
      const responses = await Promise.all(uploadPromises);
      return responses.map(res => res.file_path);
    } catch (error) {
      console.error("Failed to upload files:", error);
      throw error;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    selectedFiles,
    setSelectedFiles,
    uploadAllFiles,
    isUploading,
  };
};
